import {z} from 'zod'

export const OrganizationListItemSchema = z
    .object({
        id: z.string(),
        name: z.string(),
        campaign_goal: z.number(),
        has_data: z.boolean(),
        created_at: z.string(),
    })
    .transform(({campaign_goal, has_data, created_at, ...rest}) => ({
        ...rest,
        campaignGoal: campaign_goal,
        hasData: has_data,
        createdAt: created_at,
    }))

export type OrganizationListItem = z.infer<typeof OrganizationListItemSchema>

export const OrganizationDetailSchema = z
    .object({
        id: z.string(),
        name: z.string(),
        campaign_goal: z.number(),
        topline_percentage: z.number(),
        has_data: z.boolean(),
        created_at: z.string(),
        managers: z.array(z.string()),
        use_rfm_for_engagement: z.boolean(),
    })
    .transform(
        ({
            campaign_goal,
            topline_percentage,
            has_data,
            created_at,
            use_rfm_for_engagement,
            ...rest
        }) => ({
            ...rest,
            campaignGoal: campaign_goal,
            toplinePercentage: topline_percentage,
            hasData: has_data,
            createdAt: created_at,
            useRfmForEngagement: use_rfm_for_engagement,
        }),
    )

export type OrganizationDetail = z.infer<typeof OrganizationDetailSchema>
/**
 * The raw API response type for organization detail.
 * @see OrganizationDetailSchema
 */
export type OrganizationDetailRaw = z.input<typeof OrganizationDetailSchema>
